import Head from "next/head";

import ShipvistaConnectMain from "@/components/fulfilment-partners/shipvista-connect-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import pageSeoData from "@/data/seo/page-data.json";
import { GetStaticProps } from "next";
import { PageSeoHeaderProps } from "@/@types/SeoHeader";
import ShipvistaConnectMain2 from "@/components/fulfilment-partners/shipvista-connect-main2";

export default function ShipvistaConnect({ seoData }: PageSeoHeaderProps) {
  return (
    <>
      <Head>
        <title>{seoData.title}</title>
        <SeoMetaData data={seoData} />
      </Head>

      <ShipvistaConnectMain2 />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: { seoData: pageSeoData.PARTNER_SHIPVISTA_CONNECT },
  };
};
